module.exports = __webpack_public_path__ + "static/media/carousel-sample-1.762da0e6.png";